;
define("transaction_line_views_tax.tpl", function(){});

